import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportProfileNonAuthoritative } from 'dashboard/models/report/profile-non-authoritative';

interface ProfileNonAuthoritativeProps {
  report: ReportProfileNonAuthoritative;
  isRedacted: boolean;
}

function mergeNames(firstName: string, middleName?: string, lastName?: string): string {
  if (middleName) {
    return `${firstName} ${middleName} ${lastName || ''}`.trim();
  } else {
    return `${firstName} ${lastName || ''}`.trim();
  }
}

export const ProfileNonAuthoritative = ({ report, isRedacted }: ProfileNonAuthoritativeProps) => {
  const query = report.attributes.query;

  if (query == null) {
    return <></>;
  }

  const {
    'name-first': nameFirst,
    'name-middle': nameMiddle,
    'name-last': nameLast,
    'address-city': addressCity,
    'address-subdivision': addressSubdivision,
    'email-address': emailAddress,
    'phone-number': phoneNumber,
  } = query ?? {};

  return (
    <AttributeGrid>
      {phoneNumber && (
        <AttributeItem
          title='Phone number'
          value={phoneNumber}
          placeholder='N/A'
          isRedacted={isRedacted}
        />
      )}
      {emailAddress && (
        <AttributeItem
          title='Email address'
          value={emailAddress}
          placeholder='N/A'
          isRedacted={isRedacted}
        />
      )}
      {nameFirst && (
        <AttributeItem
          title='Name'
          value={mergeNames(nameFirst, nameMiddle, nameLast)}
          placeholder='N/A'
          isRedacted={isRedacted}
        />
      )}
      {addressCity && (
        <AttributeItem
          title='Locality'
          value={addressCity}
          placeholder='N/A'
          isRedacted={isRedacted}
        />
      )}
      {addressSubdivision && (
        <AttributeItem
          title='Subdivision'
          value={addressSubdivision}
          placeholder='N/A'
          isRedacted={isRedacted}
        />
      )}
    </AttributeGrid>
  );
};
